import React, { useMemo, useEffect } from 'react';
import * as Survey from 'survey-react';
import 'survey-react/survey.css';
import { attachKatexToSurveyModel } from '../utils/surveyKatex';

/**
 * Componente para mostrar un cuestionario con KaTeX
 * @param {Object} json - El JSON del cuestionario
 * @param {Object} data - Los datos del cuestionario
 * @param {Object} surveyProps - Las propiedades del cuestionario
 * @returns {JSX.Element}
 */
export default function SurveyWithKatex({ json, data, ...surveyProps }) {
  const jsonKey = typeof json === 'string' ? json : JSON.stringify(json);
  const dataKey = data != null
    ? (typeof data === 'string' ? data : JSON.stringify(data))
    : null;

  const model = useMemo(() => {
    const surveyModel = new Survey.Model(json);
    attachKatexToSurveyModel(surveyModel);
    if (data != null) {
      surveyModel.data = data;
    }
    return surveyModel;
  }, [jsonKey]);

  useEffect(() => {
    if (data != null) {
      model.data = data;
    }
  }, [model, dataKey]);

  return <Survey.Survey model={model} {...surveyProps} />;
}
